import React, { createContext, useContext, useState, useCallback } from 'react';
import { useCloudTimer } from './useCloudTimer';

type TimerApi = ReturnType<typeof useCloudTimer> & {
  fullscreen: boolean;
  openFullscreen: () => void;
  closeFullscreen: () => void;
};

const Ctx = createContext<TimerApi | null>(null);

export function useTimer(): TimerApi {
  const c = useContext(Ctx);
  if (!c) throw new Error('useTimer must be used within TimerProvider');
  return c;
}

export function TimerProvider({ uid, children }: { uid?: string; children: React.ReactNode }) {
  const timer = useCloudTimer(uid);
  const [fullscreen, setFullscreen] = useState(false);

  const openFullscreen = useCallback(() => {
    setFullscreen(true);
    document.documentElement.requestFullscreen?.().catch(() => { /* user can still use it windowed */ });
  }, []);

  const closeFullscreen = useCallback(() => {
    setFullscreen(false);
    if (document.fullscreenElement) document.exitFullscreen?.().catch(() => { /* */ });
  }, []);

  return (
    <Ctx.Provider value={{ ...timer, fullscreen, openFullscreen, closeFullscreen }}>
      {children}
    </Ctx.Provider>
  );
}
